import { Search } from "lucide-react";

/**
 * Pill search input matching Command Center visual language.
 */
export function NexaSearch({ value, onChange, placeholder = "Search", width = "w-56", testId }) {
  return (
   <div className="flex items-center gap-1.5 lux-card px-2.5 h-7 rounded-full shadow-none">
      <Search className="w-3 h-3 text-nexa-mute" strokeWidth={1.5} />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className={`bg-transparent outline-none text-[10px] w-40 placeholder:text-nexa-mute/70`}
        placeholder={placeholder}
      />
    </div>
  );
}
